import { 
  FormControl, FormLabel, 
} from '@chakra-ui/react';

import { Field, getIn } from 'formik';

import { CustomDatepicker } from "../CustomDatepicker";

const CustomDatepickerArray = ({ name, arrayFieldName, fieldName, index,  label, placeholder }) => {

  return (
    <Field
      name={name}
    >
      {
        ({ field, form }) => {
          const error = getIn(form.errors, name);
          const touch = getIn(form.touched, name);

          return (
            <FormControl 
              id={name}
              isInvalid={touch && error} 
            >
              <FormLabel 
                color="#5F6377"
                fontWeight="500"
                fontSize="14px"
                lineHeight="19.6px"
                htmlFor={name}
              >
                {label}
              </FormLabel>
              <CustomDatepicker
                value={form.values[arrayFieldName][index][fieldName]}
                setValue={(date) => form.setFieldValue(name, date)}
                placeholder={placeholder}
              />
            </FormControl>
          )
        }
      }
    </Field>
  );
}

export default CustomDatepickerArray;